import { useMemo, useState } from 'react';
import { clothing, crops, furniture } from '../../../data/config';
import { dailySelection } from '../domain/shopRules';
import { useGameStore } from '../../../store/gameStore';
import { useUiStore } from '../../../store/uiStore';

type ShopTab = 'seed' | 'furniture' | 'clothing';

export function ShopPage() {
  const [tab, setTab] = useState<ShopTab>('seed');
  const game = useGameStore((state) => state.game);
  const actions = useGameStore((state) => state.actions);
  const showNotice = useUiStore((state) => state.showNotice);
  const dailyFurniture = useMemo(
    () => dailySelection(furniture, game.player.playerId, game.quests.dateKey, 12),
    [game.player.playerId, game.quests.dateKey],
  );
  const dailyClothing = useMemo(
    () => dailySelection(clothing, game.player.playerId, game.quests.dateKey, 15),
    [game.player.playerId, game.quests.dateKey],
  );

  const run = (result: ReturnType<typeof actions.buySeeds>) => {
    if (!result.ok) showNotice(result.message);
  };

  return (
    <section className="page-card shop-page">
      <div className="page-title">
        <div>
          <span className="eyebrow">每日集市</span>
          <h1>花田商店</h1>
        </div>
        <span>🪙 {game.player.coins}</span>
      </div>
      <div className="tabs">
        <button className={tab === 'seed' ? 'active' : ''} onClick={() => setTab('seed')}>
          种子
        </button>
        <button className={tab === 'furniture' ? 'active' : ''} onClick={() => setTab('furniture')}>
          家具
        </button>
        <button className={tab === 'clothing' ? 'active' : ''} onClick={() => setTab('clothing')}>
          服装
        </button>
      </div>
      <div className="shop-grid">
        {tab === 'seed' &&
          crops.map((crop) => (
            <article className="shop-card" key={crop.id}>
              <span className="shop-emoji">{crop.emoji}</span>
              <h3>{crop.name}种子</h3>
              <p>
                {crop.growSeconds < 3600
                  ? `${crop.growSeconds / 60}分钟`
                  : `${crop.growSeconds / 3600}小时`}
                成熟
              </p>
              <button
                disabled={crop.unlockLevel > game.player.level}
                onClick={() => run(actions.buySeeds(crop.id, 5))}
              >
                {crop.unlockLevel > game.player.level
                  ? `Lv.${crop.unlockLevel}解锁`
                  : `🪙 ${crop.seedPrice * 5} / 5颗`}
              </button>
            </article>
          ))}
        {tab === 'furniture' &&
          dailyFurniture.map((item) => (
            <article className="shop-card" key={item.id}>
              <span className="furniture-preview" style={{ background: item.color }} />
              <h3>{item.name}</h3>
              <p>
                {item.width}×{item.height}格
              </p>
              <button
                disabled={item.unlockLevel > game.player.level}
                onClick={() => run(actions.buyFurniture(item.id))}
              >
                {item.unlockLevel > game.player.level
                  ? `Lv.${item.unlockLevel}解锁`
                  : `🪙 ${item.price}`}
              </button>
            </article>
          ))}
        {tab === 'clothing' &&
          dailyClothing.map((item) => {
            const owned = game.wardrobe.ownedClothingIds.includes(item.id);
            return (
              <article className="shop-card" key={item.id}>
                <span className="clothing-preview" style={{ background: item.color }} />
                <h3>{item.name}</h3>
                <p>{owned ? '已经拥有' : '今日精选'}</p>
                <button
                  disabled={owned || item.unlockLevel > game.player.level}
                  onClick={() => run(actions.buyClothing(item.id))}
                >
                  {owned
                    ? '已拥有'
                    : item.unlockLevel > game.player.level
                      ? `Lv.${item.unlockLevel}解锁`
                      : `🪙 ${item.price}`}
                </button>
              </article>
            );
          })}
      </div>
    </section>
  );
}
